import PropTypes from 'prop-types';
// material-ui
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import { DownOutlined, UpOutlined, FolderOutlined } from '@ant-design/icons';

// project import
import NavItem from './NavItem';
import { useGetMenuMaster } from 'api/menu';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

export default function NavGroup({ item, open, onClick }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const navCollapse = item.children?.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return (
          <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
            collapse - only available in paid version
          </Typography>
        );
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <ListItemButton
            onClick={onClick}
            sx={{
              py: 1,
              px: 3,
              mb: 0.5,
              borderRadius: 2.5,
              '&:hover': {
                bgcolor: 'action.selected',
                borderLeft: '3px solid',
                borderColor: 'primary.main'
              }
            }}
          >
            <ListItemText
              primary={
                <Typography variant="body1" sx={{ color: 'text.primary', fontWeight: 500 }}>
                  {item.title}
                </Typography>
              }
            />
          </ListItemButton>
        )
      }
      sx={{ mb: drawerOpen ? 0.5 : 0, py: 0, zIndex: 0 }}
    >
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ pl: 1 }}>{navCollapse}</Box>
      </Collapse>
    </List>
  );
}

NavGroup.propTypes = {
  item: PropTypes.object,
  open: PropTypes.bool,
  onClick: PropTypes.func
};
